module.exports = __webpack_public_path__ + "img/169.c25db42e.jpg";